(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menutablet"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.cmReady) return;
    root.dataset.cmReady = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    const owner = root.closest('.shopify-section');
    const locked = root.dataset.lockPage === 'true';
    if (locked) {
      document.documentElement.classList.add('cm-page');
      document.body.classList.add('cm-page');
      if (owner) owner.setAttribute('data-cm-owner', '');
    }
    const nav = root.querySelector('.cm-nav');
    const sticky = root.querySelector('.cm-sticky');
    const links = Array.from(nav.querySelectorAll('[data-cm-link]'));
    const categories = Array.from(root.querySelectorAll('[data-cm-category]'));
    const dialog = root.querySelector('.cm-dialog');
    const dialogContent = dialog.querySelector('.cm-dialog-content');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = '';
    let frame = 0;
    let savedOverflow = null;
    let opener = null;
    const select = (key) => {
      if (current === key) return;
      current = key;
      links.forEach((link) => {
        const active = link.dataset.cmLink === key;
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        if (active) nav.scrollTo({left: link.offsetLeft - nav.offsetLeft - (nav.clientWidth - link.offsetWidth) / 2, behavior: reduced.matches ? 'auto' : 'smooth'});
      });
    };
    const update = () => {
      frame = 0;
      const threshold = sticky.getBoundingClientRect().height + 85;
      let key = categories[0].dataset.cmCategory;
      categories.forEach((category) => {if (category.getBoundingClientRect().top <= threshold) key = category.dataset.cmCategory;});
      select(key);
    };
    const schedule = () => {if (!frame) frame = requestAnimationFrame(update);};
    const resize = new ResizeObserver(() => {root.style.setProperty('--cm-sticky', `${sticky.offsetHeight}px`); schedule();});
    resize.observe(sticky);
    window.addEventListener('scroll', schedule, {passive: true, signal});
    links.forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      const category = categories.find((target) => target.dataset.cmCategory === link.dataset.cmLink);
      if (category) category.scrollIntoView({behavior: reduced.matches ? 'auto' : 'smooth', block: 'start'});
    }, {signal}));
    const releaseOverflow = () => {
      if (savedOverflow !== null) {document.documentElement.style.overflow = savedOverflow; savedOverflow = null;}
    };
    const closeDialog = () => {if (dialog.open) dialog.close();};
    root.addEventListener('click', (event) => {
      const button = event.target.closest('.cm-product');
      if (!button || !root.contains(button)) return;
      const item = button.closest('.cm-item');
      dialogContent.replaceChildren();
      const photo = button.querySelector('.cm-photo').cloneNode(true);
      const copy = button.querySelector('.cm-copy').cloneNode(true);
      const title = copy.querySelector('.cm-title');
      const heading = document.createElement('h2');
      heading.className = 'cm-title';
      heading.id = `cm-dialog-title-${root.id.replace('CrunchillMenu-', '')}`;
      heading.textContent = title.textContent;
      title.replaceWith(heading);
      photo.querySelectorAll('img').forEach((img) => {img.loading = 'eager'; img.removeAttribute('fetchpriority');});
      dialogContent.append(photo, copy);
      const options = item.querySelector('.cm-options-source');
      if (options) {const expanded = options.cloneNode(true); expanded.hidden = false; dialogContent.append(expanded);}
      opener = button;
      if (savedOverflow === null) savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      dialog.scrollTop = 0;
    }, {signal});
    dialog.querySelectorAll('.cm-dialog-close,.cm-dialog-done').forEach((button) => button.addEventListener('click', closeDialog, {signal}));
    dialog.addEventListener('click', (event) => {if (event.target === dialog) {const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog();}}, {signal});
    dialog.addEventListener('close', () => {releaseOverflow(); if (opener && document.contains(opener)) opener.focus({preventScroll: true});}, {signal});
    const handleImageError = (img) => {
      if (img.dataset.cmFailed) return;
      img.dataset.cmFailed = 'true';
      img.hidden = true;
      const photo = img.closest('.cm-photo');
      if (photo && !photo.querySelector('.cm-photo-fallback')) {const text = document.createElement('span'); text.className = 'cm-photo-fallback'; text.textContent = img.alt; photo.append(text);}
    };
    root.querySelectorAll('img').forEach((img) => {img.addEventListener('error', () => handleImageError(img), {signal}); if (img.complete && !img.naturalWidth) handleImageError(img);});
    document.addEventListener('shopify:block:select', (event) => {if (owner && owner.contains(event.target)) {const item = event.target.closest('.cm-item'); if (item) item.scrollIntoView({block: 'center', behavior: 'auto'});}}, {signal});
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target !== owner) return;
      closeDialog();
      releaseOverflow();
      resize.disconnect();
      cancelAnimationFrame(frame);
      controller.abort();
      root.removeAttribute('data-cm-ready');
      if (owner) owner.removeAttribute('data-cm-owner');
      if (!document.querySelector('[data-cm-owner]')) {document.documentElement.classList.remove('cm-page'); document.body.classList.remove('cm-page');}
    }, {signal});
    update();
  };
  document.querySelectorAll('[data-crunchill-menu]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-crunchill-menu]').forEach(initialize));
})();


  } catch(e) { console.error(e); }
})();
})();
